<template>
  <div>
    <div class="d-flex ratings-box mt-2 pt-2">
      <div class="property-column">
        <v-rating class="custom-rating"
            color="yellow darken-1"
            background-color="gray"
            half-increments
            length="5"
            value="0"
            dense
            size="18"
            readonly
            :value="this.puzzleProduct.attributes.imageQuality"
        ></v-rating>
        <div>Image Quality</div>
      </div>
      <div class="property-column">
        <v-rating class="custom-rating"
            color="yellow darken-1"
            background-color="gray"
            half-increments
            length="5"
            value="0"
            dense
            size="18"
            readonly
            :value="this.puzzleProduct.attributes.difficulty"
        ></v-rating>
        <div>Difficulty</div>
      </div>
      <div class="property-column">
        <v-rating class="custom-rating"
          color="yellow darken-1"
          background-color="gray"
          half-increments
          length="5"
          value="0"
          dense
          size="18"
          readonly
          :value="this.puzzleProduct.attributes.pieceFit"
        ></v-rating>
        <div>Piece fit</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";

export default {
  name: 'ratings_sub_display',
  components: {
  },
  computed: {
    ...mapGetters({
    }),
    ...mapState({
    }),
  },
  created: function(){
  },
  mounted: function(){
  },
  methods: {

  },
  watch: {

  },
  data: function() {
    return {}
  },
  props: {
    puzzleProduct: {
      rating: 0,
      imageQuality: 0,
      pieceFit: 0,
      difficulty: 0,
      reviewCount: 0
    }
  }
}
</script>
<style scoped>

  .property-column {
    flex: 1 1 33%;
    min-width: max-content;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  /deep/ .custom-rating .v-icon {
    padding: 0 !important;
    margin: -2px !important;
  }
  .custom-rating {
    margin-bottom: -4px;
  }
  .ratings-box {
    border-top: 2px solid #f0f1f3;
    font-size: 13px;
    flex-wrap: wrap;
  }
</style>